module.exports = __webpack_public_path__ + "fonts/6a9e75c.woff";